/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div class="swiper-container" v-if="(homeOrderList && homeOrderList.length > 0 && showOrders)"><mpx-swiper display-multiple-items="1" @change="onChange" :indicator-dots="(false)" indicator-color="#FFFFFF" :current="(current)" :autoplay="(true)" :interval="(100000000000000000)" :circular="(false)" previous-margin="10px" next-margin="10px" easing-function="linear" :observer="(true)" :observeParents="(true)" ref="swiper" :scroll-options="({          eventPassthrough: 'vertical'        })" class="swiper"><div v-for="(item, index) in (homeOrderList)" :key="item.index"><mpx-swiper-item class="swiper-item"><div :class="(homeOrderList.length === 1 ? 'train-info-content-single' : 'train-info-content')" :style="[((homeOrderList.length > 1&&(index===homeOrderList.length-1)) ? 'padding-right: 0px' : '')] | transRpxStyle"><schedule-item :homeOrderItem="(item)" :isSingleOrder="(isSingleOrder)" @refresh="refresh"/></div></mpx-swiper-item></div></mpx-swiper><div class="process" v-if="(homeOrderList.length > 1)"><div v-for="(item, index) in (homeOrderList.length)" :class="({'process-active': index === current})" class="process-item"></div></div></div><div :style='["height: 184px"] | transRpxStyle' v-if="(homeOrderList && !showOrders && homeOrderList.length>0 && showBox)"></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m14577018"}'>
  @import '~@/mixins/stylus/color.styl'

  .swiper-container
    overflow visible
    margin-top 8px
  .swiper
    width 100%
    // height 113px
    // background-color #FFFFFF
    overflow visible
  .swiper-inline-didi-padding
    margin-top -18px
    padding 0px 0px 0px 0px
    margin-bottom -12px
  .swiper-inline-didi-padding-reason
    margin-top -10px
    padding 0px 0px 0px 0px
    margin-bottom -4px
  .swiper-didi-padding
    padding 0px 0px
  .swiper-item
    // height 105px
    display flex
    justify-content center
    align-items center
  .train-info-content
    display flex
    flex-direction column
    width 99%
    // background-color #ffffff
    border-radius 8px
    box-sizing border-box
    padding-right 5px
  .train-info-content-single
    display flex
    flex-direction column
    width 93vw
    // background-color #ffffff
    border-radius 8px
    box-sizing border-box
  .unselected-item
    transform scale(0.75, 1)
  .train-info-item
    padding 13px 15px 16px 15px
  .train-info-item-top
    padding 3px 15px 16px 15px
  .process
    margin-top 6px
    display flex
    align-items center
    justify-content center
    &-item
      width 4px
      height 2px
      background #FFFFFF
      border-radius 50px
      &:not(:first-child)
        margin-left 2px
    &-active
      width 8px
      height 2px
      background #222222
      border-radius 50px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m14577018"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex14577018%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex14577018%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m14577018"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index14577018/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'schedule-item':getComponent(require("./schedule-item.mpx?isComponent&outputPath=components%2Fschedule-item79a99562%2Findex")),'mpx-swiper':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-swiper.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-swiper-item':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-swiper-item.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
